//  handler to store data of homepage form data
export const setHomePageFormData = (payload: any, dispatch: any) => {
  dispatch({
    type: "SET_HOMEPAGE_FORM_DATA",
    payload: payload,
  });
};
